// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalBackdrop_container__WiL9A","preventScroll":"ModalBackdrop_preventScroll__1L5nN"};